import React, { useEffect, useRef, useState } from 'react';
import './collaborators-org.styles.scss';
import { getUniqueDocumentFromDb } from '@/utils/getDataFromDb';
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { sortPlayers } from '@/utils/sortPlayers';
import AddCollaboratorModal from './add-collaborator-modal.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useSelector } from 'react-redux';
import { getEmailContent } from '@/utils/getEmailContent';
import { getDownloadURL, getStorage, ref } from 'firebase/storage';
import CollabListItem from './collab-list-item.component';
import FullPageLoader from '@/components/loader/full-page-loader.component';
import useAnalytics from '@/utils/useAnalytics';

const CollaboratorsOrg = ({
  gameData,
  orgs,
  pendingInvites,
  setCollabSystem,
  removeCollaborator
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const membership = useSelector(state => state.userData.membership);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [orgMembers, setOrgMembers] = useState(null);
  const [gameRegs, setGameRegs] = useState(null);
  const [collabs, setCollabs] = useState([]);
  const [showAddCollabModal, setShowAddCollabModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const { trackEvent, trackException } = useAnalytics();
  const approveRef = useRef();
  const regsRef = useRef();
  const newCollabRef = useRef();
  const storage = getStorage();
  let membersListener;
  let regsListener;


  useEffect(() => {

    return () => {
      if (membersListener) membersListener();
      if (regsListener) regsListener();
    }
  }, [])

  useEffect(() => {
    if (!selectedOrg) return;
    console.log('selected org changed: ' + selectedOrg);
    if (selectedOrg) {
      getOrgData();
    }
  }, [selectedOrg])

  useEffect(() => {
    if (!gameData) return;
    if (gameData.gameId) {
      getGameRegs();
    }
    if (gameData.orgId) {
      setSelectedOrg(gameData.orgId);
    }
  }, [gameData])

  useEffect(() => {
    console.log(orgMembers);
    console.log(gameRegs);
    if (!orgMembers || !gameRegs) return;
    let collabArr = []

    for (let appId of Object.keys(gameRegs.roles)) {
      if (!orgMembers[appId]) continue;
      if (
        gameRegs.roles[appId].length === 1 &&
        gameRegs.roles[appId][0] === 'player'
      ) continue;
      const member = orgMembers[appId];
      let tempRoles = [...gameRegs.roles[appId]];
      if (tempRoles.includes('player')) {
        tempRoles.splice(tempRoles.indexOf('player'), 1);
      }
      const role = tempRoles[0];
      const order =
        role === 'owner' ? 0 :
          role === 'manager' ? 1 : 2;
      const obj = {
        'fName': member.fName,
        'lName': member.lName,
        'icon': member.icon,
        'gradient': member.gradient,
        'appId': appId,
        'role': role,
        'order': order
      }
      collabArr.push(obj);
    }
    setCollabs(sortPlayers({
      'playerList': collabArr
    }));
    console.log(gameRegs);
  }, [orgMembers, gameRegs])

  async function createOrgConnection(orgId) {
    
    console.log('creating org connection: ' + orgId);
    const res = await UseCloudFunction(
      'setOrgGameConnection',
      {
        'appId': userProfile.appId,
        'gameId': gameData.gameId,
        'orgId': orgId,
      }
    );
    console.log(res);
    if (res.error) {
      setAlertMessage(`Sorry, something went wrong. Try again later. (Error: ${res.error})`);
      return;
    }
    setSelectedOrg(orgId);
  }

  async function getOrgData() {
    console.log(selectedOrg);
    // saveData('orgId', selectedOrg);
    const res = await UseCloudFunction(
      'getOrgData',
      {
        'orgId': selectedOrg,
        'appId': userProfile.appId,
        'noInvites': true
      }
    );
    console.log(res);
    if (res.error) {
      setAlertMessage(`Sorry, something went wrong. Try again later. (Error: ${res.error})`);
      return;
    }
    setOrgMembers(res.members);
  }

  function getGameRegs() {
    console.log('getting game regs: ' + gameData.gameId)
    getUniqueDocumentFromDb({
      'collection': `games/${gameData.gameId}/registrations`,
      'docId': `${gameData.gameId}-regs`,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      regsRef.current = { ...data };
      setGameRegs(regsRef.current);
    }
    function handleListener(unsub) {
      regsListener = unsub;
    }
  }

  function removeOrgConnection() {
    if (gameData.orgId) {
      setConfirmMessage('Are you sure you want to change the Organization from which you can ' +
        'add collaborators? Games can only be shared within one organization.<br /><br />' +
        '<b>Warning</b>: This will remove from the game any existing collaborators from your game. ' +
        'This action cannot be undone and will take place when you click "OK".')
      approveRef.current = () => {
        continueRemoveOrgConnection();
      }
    }

    async function continueRemoveOrgConnection() {
      const res = await UseCloudFunction(
        'removeExistingCollaborators',
        {
          'appId': userProfile.appId,
          'gameId': gameData.gameId,
        }
      )
      console.log(res);
      if (res.error) {
        setAlertMessage(`Sorry, something went wrong. Please try again later. (Error: ${res.error})`);
        trackException('Error removing collaborators: ' + res.error);
        return;
      }
      setCollabSystem(null);
      trackEvent(
        'org_connection_removed', 
        'Game Manager',
        `Removed organization connection from game`,
        null,
        membership
      )
    }
  }

  function inviteCollaborators(collabArr) {
    setConfirmMessage('Are you sure you want to invite the selected organization members as ' +
      'collaborators? Invited members will receive an email with instructions on how to access '
      + 'the game.');
    approveRef.current = () => {
      sendInvites(collabArr);
    }

    async function sendInvites(collabArr) {
      setLoading(true);
      // set temp game data
      // and get gameIcon url
      let tempGameData = { ...gameData };
      let gameIcon = null;
      if (
        tempGameData.icon &&
        typeof tempGameData.icon === 'string' &&
        tempGameData.icon.includes('storage:')
      ) {
        const path = tempGameData.icon.split('storage:')[1];
        const imageRef = ref(storage, path);
        const url = await getDownloadURL(imageRef);
        gameIcon = url;
      } else if (tempGameData.icon && tempGameData.icon.includes('http')) {
        gameIcon = tempGameData.icon;
      } else {
        gameIcon = `https://app.gamably.com${tempGameData.icon}`;
      }
      tempGameData.orgId = selectedOrg;
      const emailContentArr = [];

      for (let collab of collabArr) {
        const appId = collab.appId;  
        const role = collab.role;
        const orgMemberData = orgMembers[appId];
        if (!orgMemberData) {
          setAlertMessage(`Sorry, something went wrong. Please try again later. (Error: missing org member data)`);
          return;
        };
        const emailContent = getEmailContent(
          'gameManagerInvite',
          {
            'email': orgMemberData.email,
            'inviteAppId': appId,
            'appId': userProfile.appId,
            'gameName': tempGameData.gameName,
            'userName': `${orgMemberData.fName} ${orgMemberData.lName}`,
            'fName': orgMemberData.fName,
            'lName': orgMemberData.lName,
            'gameIcon': gameIcon,
            'role': role,
            'managerName': `${userProfile.fName} ${userProfile.lName}`,
          }
        );
        emailContentArr.push(emailContent);
      }
      console.log(emailContentArr);
      const res = await UseCloudFunction(
        'saveGame',
        {
          'gameObj': tempGameData,
          'profile': userProfile,
          'action': 'save collabs',
          'emailContentArr': emailContentArr,
        }
      )
      if (res.error) {
        setAlertMessage(`Something went wrong. Please try again later. (Error:${res.error})`);
        setLoading(false);
        trackException('Error inviting ORG collaborators: ' + res.error);
        return;
      }
      setAlertMessage('Settings saved successfully!')
      setLoading(false);
      trackEvent(
        'collaborators_invited_from_org', 
        'Game Manager',
        `Invited collaborators from organization`,
        null,
        membership
      )
      }
  }

  return (
    <div className='collaborators-org'>
      <hr />
      {
        (gameData && orgs) &&
        <div className='collab-card'>
          <div className='header-with-button'>
            <h3>
              <ImageContainer src="/images/icons/enterprise.png" className='icon' />
              Invite Organization Members</h3>
            {
              (gameData.orgId) &&
                <button
                  className='g-button small-btn'
                  onClick={() => removeOrgConnection()}>
                  Remove Org Connection
                  <FontAwesomeIcon icon={faBan} />
                </button>
            }
          </div>
          <div className="g-space-1"></div>
          <div className='g-list-item grey-background'>
            <div className="g-space-1"></div>
            {
              (gameData.orgId && orgs[gameData.orgId])
                ?
                <div className='org-box field'>
                  <label>Chosen Organization</label>
                  <div className='g-list-item'>
                    <div className='card-title'>
                      <ImageContainer
                        src={orgs[gameData.orgId].icon ?? '/images/icons/placeholder-icon-org.jpg'}
                        className='head-icon' />
                      {orgs[gameData.orgId].name}
                    </div>
                    <div className='change'>
                      <button
                        className='g-button text-only'
                        onClick={() => removeOrgConnection()} >
                        Change
                      </button>
                    </div>
                  </div>
                </div>
                :
                <div className='field small'>
                  <label>Choose an Organization</label>
                  <select
                    className='med-input'
                    value={selectedOrg ?? ''}
                    onChange={(e) => createOrgConnection(e.target.value)}>
                    <option value=''>Choose...</option>
                    {
                      (orgs && Object.values(orgs).length > 0) &&
                      Object.values(orgs)
                        .sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                        .map(org => (
                          <option
                            key={org.orgId}
                            value={org.orgId}>
                            {org.name}
                          </option>
                        ))
                    }
                  </select>
                </div>
            }
            <div className='g-space-1'></div>
            {
              (selectedOrg || gameData.orgId) &&
              <div className='field'>
                <label>Collaborators</label>
                <div className='g-list-item collab-list-div'>
                  <div className="g-space-0-5"></div>
                  <button
                    className='g-button med-btn'
                    onClick={() => setShowAddCollabModal(true)} >
                    Add Collaborator
                    <FontAwesomeIcon icon={faPlusCircle} className='icon' />
                  </button>
                  <div className="g-space-1"></div>
                  <div className='collab-list'>
                    {
                      (collabs.length > 0)
                        ?
                        collabs.sort((a, b) => a.order > b.order ? 1 : -1)
                          .map(c => (
                            <CollabListItem
                              key={c.appId}
                              collab={c}
                              removeCollaborator={removeCollaborator} />
                          ))
                        :
                        <div>No collaborators yet...</div>
                    }
                  </div>
                  <div className="g-space-0-5"></div>
                </div>
              </div>
            }
            <div className="g-space-1"></div>
            
            <div className='field'>
              <label>Pending Invites</label>
              <div className='g-list-item collab-list-div'>
                <div className="g-space-0-5"></div>
                <div className='collab-list'>
                  {
                    (pendingInvites && Object.keys(pendingInvites).length > 0) 
                    ?
                    Object.values(pendingInvites)
                      .map((invite, index) => {
                        if (collabs.find(c => c.appId === invite.inviteAppId)) {
                          return null;
                        }
                        return (
                        <CollabListItem
                            key={invite.inviteAppId + index}
                            collab={invite}
                            removeCollaborator={removeCollaborator} />
                        ) 
                      })
                      :
                    <div>No pending invites...</div>
                  }
                </div>
                <div className="g-space-0-5"></div>
              </div>
            </div>
            
          </div>
          {/* <div className="g-space-1"></div>
          {
            (loading)
              ?
              <div className='buttons'>
                <button className='g-button'>
                  Cancel
                </button>
                <button className='g-button'>
                  <ThreeDotsLoader />
                </button>
              </div>
              :
              <div className='buttons'>
                <button
                  className='g-button'
                  onClick={() => navigate(-1)}>
                  Cancel
                </button>
                <button
                  className={`g-button primary ${isDirty ? '' : 'disabled'
                    }`}
                  onClick={() => saveCollabSettings()}>
                  Save Changes
                </button>
              </div>
          } */}
        </div>
      }

      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage} />
      <ModalConfirm
        show={confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
      <AddCollaboratorModal
        gameData={gameData}
        showAddCollabModal={showAddCollabModal}
        setShowAddCollabModal={setShowAddCollabModal}
        orgMembers={orgMembers}
        collabs={collabs}
        inviteCollaborators={inviteCollaborators} />
      <FullPageLoader show={loading} />
    </div>
  )
}

export default CollaboratorsOrg